/* ============
 * Getters for the patient module
 * ============
 *
 * The getters that are available on the
 * patient progress module.
 */
import { clone } from '@/utils/object';

const getresolveActionsList = state => clone(state.resolveActionsList);

export default {
  getresolveActionsList
};
